// extracted by mini-css-extract-plugin
export default {"editor":"Support_editor__WWTj-","help":"Support_help__SW9jG"};